import { useMemo } from 'react';
import useBasket from '../../hooks/basket/useBasket';
import useAuth from '../../hooks/global/useAuth';
import OrderBasketCashback from '../cashback/OrderBasketCashback';
import { Card, CardContent } from '../ui/card';
import CashbackToggle from './CashbackToggle';
import classnames from 'classnames';
import { CashbackToggleType } from './CashbackToggle';
import useCashbackProgram from '../../hooks/cashback/useCashbackProgram';

interface Props {
  className?: string;
}

const LoyaltyPoints = ({ className }: Props): JSX.Element | null => {
  const { isLoggedIn } = useAuth();
  const { subtotal } = useBasket();
  const { calculateExpectedCashback } = useCashbackProgram();
  const expectedCashback = useMemo(() => calculateExpectedCashback(subtotal), [subtotal, calculateExpectedCashback]);

  if (!isLoggedIn) {
    return expectedCashback > 0 ? (
      <Card className={classnames('bg-accent/5 border-accent/20', className)}>
        <CardContent className="p-sm space-y-3">
          <div className="flex items-center gap-2">
            <span className="text-lg">✨</span>
            <p className="text-sm text-brand-text-secondary font-medium">
              <OrderBasketCashback.ExpectedCashback total={subtotal} pointsHighlight="text-brand-text-primary" />
            </p>
          </div>
        </CardContent>
      </Card>
    ) : null;
  }

  return (
    <CashbackToggle
      subtotal={subtotal}
      className={classnames('bg-gray-1100 dark:bg-brand-primary/30 rounded-lg p-sm', className)}
      type={CashbackToggleType.Points}
      header={
        <div className="flex items-center gap-2 border-b-xs border-border pb-sm">
          <span className="text-lg">✨</span>
          <p className="text-sm text-brand-text-secondary font-medium">
            <OrderBasketCashback.ExpectedCashback total={subtotal} pointsHighlight="text-brand-text-primary" />
          </p>
        </div>
      }
    />
  );
};

export default LoyaltyPoints;
